<div class="p-6 max-w-4xl mx-auto">

  <!-- Breadcrumb -->
  <nav class="flex items-center gap-2 text-sm text-gray-500 mb-5 flex-wrap">
    <a routerLink="/automation/workflows" class="hover:text-blue-600 transition-colors">Workflows</a>
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
    </svg>
    <a routerLink="/automation/workflows" class="hover:text-blue-600 transition-colors">
      {{ workflow?.name ?? 'Workflow' }}
    </a>
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
    </svg>
    <span class="text-gray-900 dark:text-white font-medium">Pruebas y activación</span>
  </nav>

  <!-- Header + navegación contextual -->
  <div class="flex items-start justify-between mb-6 gap-4 flex-wrap">
    <div>
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Pruebas y activación</h1>
      @if (workflow) {
        <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{{ workflow.name }}</p>
      }
    </div>
    <div class="flex flex-wrap gap-2">
      <a routerLink="/automation/workflows"
         class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
        </svg>
        Volver al detalle
      </a>
      <a [routerLink]="['/automation/workflows', workflowId, 'builder']"
         class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm border border-indigo-200 dark:border-indigo-700 rounded-lg hover:bg-indigo-50 dark:hover:bg-indigo-900/20 text-indigo-700 dark:text-indigo-400 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>
        </svg>
        Builder
      </a>
      <a [routerLink]="['/automation/workflows', workflowId, 'enrollments']"
         class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
        </svg>
        Inscripciones
      </a>
      <a [routerLink]="['/automation/workflows', workflowId, 'monitoring']"
         class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
        </svg>
        Monitoreo
      </a>
    </div>
  </div>

  <!-- Formulario compartido de registro -->
  <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-4 mb-6">
    <h2 class="text-sm font-semibold text-blue-800 dark:text-blue-300 mb-3">Registro de referencia (compartido)</h2>
    <div class="flex flex-wrap gap-3 items-end">
      <div>
        <label class="block text-xs text-blue-700 dark:text-blue-400 mb-1">Tipo de objeto</label>
        <select [(ngModel)]="sharedObjectType" (ngModelChange)="onSharedObjectTypeChange()"
                class="px-3 py-2 text-sm border border-blue-200 dark:border-blue-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
          @for (opt of objectTypeOptions; track opt.value) {
            <option [value]="opt.value">{{ opt.label }}</option>
          }
        </select>
      </div>
      <div class="flex-1 min-w-56">
        <label class="block text-xs text-blue-700 dark:text-blue-400 mb-1">Registro de prueba</label>
        @if (recordSelect.isSearchable()) {
          <app-entity-select
            [value]="sharedObjectId"
            (valueChange)="sharedObjectId = $event"
            (selected)="onRecordSelected($event)"
            [displayText]="recordDisplayText"
            [searchFn]="recordSelect.search" [labelFn]="recordSelect.label" [sublabelFn]="recordSelect.sublabel"
            placeholder="Buscar por nombre…"></app-entity-select>
        } @else {
          <input type="number" [(ngModel)]="sharedObjectId" min="1" placeholder="Ej: 42"
                 class="w-36 px-3 py-2 text-sm border border-blue-200 dark:border-blue-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
        }
      </div>
    </div>
    <p class="text-xs text-blue-600 dark:text-blue-400 mt-2">
      Este registro se usa en Simulación, Ejecución de prueba y Email de prueba.
    </p>
  </div>

  <div class="space-y-6">

    <!-- 1. Checklist de activación -->
    <section class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-700">
        <div>
          <h2 class="text-base font-semibold text-gray-900 dark:text-white">Checklist de activación</h2>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Valida que el workflow esté listo para activarse.</p>
        </div>
        <button (click)="runChecklist()" [disabled]="checklistLoading"
                class="inline-flex items-center gap-2 px-4 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 transition-colors">
          @if (checklistLoading) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
          }
          Validar
        </button>
      </div>

      <div class="p-5">
        @if (checklistError) {
          <p class="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-3 rounded-lg">{{ checklistError }}</p>
        }
        @if (checklist) {
          <!-- Resultado global -->
          <div class="flex items-center gap-3 mb-4 p-3 rounded-lg"
               [ngClass]="checklist.canActivate
                 ? 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800'
                 : 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800'">
            <span class="text-2xl">{{ checklist.canActivate ? '✅' : '❌' }}</span>
            <div class="flex-1">
              <p class="text-sm font-semibold"
                 [ngClass]="checklist.canActivate ? 'text-green-800 dark:text-green-300' : 'text-red-800 dark:text-red-300'">
                {{ checklist.canActivate ? 'El workflow está listo para activarse.' : 'Corrige los errores antes de activar.' }}
              </p>
              @if (getChecklistSummary()) {
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ getChecklistSummary() }}</p>
              }
            </div>
            @if (!checklist.canActivate) {
              <a [routerLink]="['/automation/workflows', workflowId, 'builder']"
                 class="shrink-0 px-3 py-1.5 text-xs bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors">
                Corregir en builder
              </a>
            }
          </div>

          <!-- Errores -->
          @if (getChecklistItems('FAILED').length > 0) {
            <div class="mb-3">
              <p class="text-xs font-semibold text-red-600 dark:text-red-400 uppercase tracking-wide mb-2">
                Errores ({{ getChecklistItems('FAILED').length }})
              </p>
              <div class="space-y-1.5">
                @for (item of getChecklistItems('FAILED'); track item.key) {
                  <div class="flex items-start gap-2 p-2.5 rounded-lg" [ngClass]="checklistItemClass('FAILED')">
                    <span class="leading-none mt-0.5">❌</span>
                    <div>
                      <p class="text-sm font-medium">{{ item.label }}</p>
                      @if (item.message) { <p class="text-xs opacity-75 mt-0.5">{{ item.message }}</p> }
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Advertencias -->
          @if (getChecklistItems('WARNING').length > 0) {
            <div class="mb-3">
              <p class="text-xs font-semibold text-amber-600 dark:text-amber-400 uppercase tracking-wide mb-2">
                Advertencias ({{ getChecklistItems('WARNING').length }})
              </p>
              <div class="space-y-1.5">
                @for (item of getChecklistItems('WARNING'); track item.key) {
                  <div class="flex items-start gap-2 p-2.5 rounded-lg" [ngClass]="checklistItemClass('WARNING')">
                    <span class="leading-none mt-0.5">⚠️</span>
                    <div>
                      <p class="text-sm">{{ item.label }}</p>
                      @if (item.message) { <p class="text-xs opacity-75 mt-0.5">{{ item.message }}</p> }
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Correctos -->
          @if (getChecklistItems('PASSED').length > 0) {
            <details class="group">
              <summary class="cursor-pointer text-xs font-semibold text-green-600 dark:text-green-400 uppercase tracking-wide mb-2 list-none flex items-center gap-1">
                <svg class="w-3 h-3 transition-transform group-open:rotate-90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
                Correctos ({{ getChecklistItems('PASSED').length }})
              </summary>
              <div class="space-y-1.5 mt-2">
                @for (item of getChecklistItems('PASSED'); track item.key) {
                  <div class="flex items-center gap-2 p-2 rounded-lg" [ngClass]="checklistItemClass('PASSED')">
                    <span>✅</span>
                    <p class="text-sm">{{ item.label }}</p>
                  </div>
                }
              </div>
            </details>
          }
        } @else if (!checklistLoading) {
          <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-4">
            Haz clic en "Validar" para ejecutar el checklist pre-activación.
          </p>
        }
      </div>
    </section>

    <!-- 2. Simulación del flujo -->
    <section class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="px-5 py-4 border-b border-gray-100 dark:border-gray-700">
        <h2 class="text-base font-semibold text-gray-900 dark:text-white">Simulación del flujo</h2>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          Traza el camino sin ejecutar acciones reales ni modificar datos.
        </p>
      </div>
      <div class="p-5">
        <div class="flex items-center gap-2 text-xs text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 px-3 py-2 rounded-lg border border-amber-200 dark:border-amber-800 mb-4">
          <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Esta simulación no ejecuta acciones reales ni modifica datos del CRM.
        </div>

        <!-- Selector de nodo de inicio -->
        <div class="mb-4">
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Iniciar desde</label>
          @if (nodesLoading) {
            <p class="text-xs text-gray-400 flex items-center gap-1">
              <svg class="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
              </svg>
              Cargando pasos...
            </p>
          } @else if (selectableNodes.length > 0) {
            <select [(ngModel)]="simStartNodeId"
                    class="w-full sm:w-80 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option [value]="null">Desde el inicio del workflow</option>
              @for (node of selectableNodes; track node.id) {
                <option [value]="node.id">{{ getNodeDisplayLabel(node) }}</option>
              }
            </select>
          } @else {
            <div class="flex items-center gap-2">
              <input type="number" [(ngModel)]="simStartNodeId" min="1" placeholder="ID del nodo (opcional)"
                     class="w-48 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
              <button type="button" (click)="loadNodes()"
                      class="px-3 py-2 text-xs border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors">
                Recargar pasos
              </button>
            </div>
          }
        </div>

        <button (click)="runSimulation()" [disabled]="simLoading"
                class="px-4 py-2 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 transition-colors flex items-center gap-2 mb-4">
          @if (simLoading) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
          }
          Simular flujo
        </button>

        @if (simError) {
          <p class="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-3 rounded-lg mb-3">{{ simError }}</p>
        }
        @if (simResult) {
          @if (simResult.warnings.length > 0) {
            <div class="mb-4 p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-200 dark:border-amber-800">
              @for (w of simResult.warnings; track $index) {
                <p class="text-xs text-amber-600 dark:text-amber-400">⚠️ {{ w }}</p>
              }
            </div>
          }

          @if (simResult.path.length === 0) {
            <p class="text-sm text-gray-400 text-center py-4">Sin pasos generados.</p>
          } @else {
            <!-- Timeline visual -->
            <div class="relative">
              @for (step of simResult.path; track $index) {
                <div class="flex gap-4 mb-2">
                  <!-- Indicador + línea -->
                  <div class="flex flex-col items-center">
                    <div class="w-8 h-8 rounded-full flex items-center justify-center text-base shrink-0 z-10"
                         [ngClass]="step.nodeType === 'CONDITION' ? 'bg-purple-100 dark:bg-purple-900/40' :
                                    step.nodeType === 'WAIT'      ? 'bg-amber-100 dark:bg-amber-900/40' :
                                    step.nodeType === 'ACTION'    ? 'bg-blue-100 dark:bg-blue-900/40' :
                                    'bg-gray-100 dark:bg-gray-700/40'">
                      {{ getSimStepIcon(step) }}
                    </div>
                    @if ($index < simResult.path.length - 1) {
                      <div class="w-0.5 flex-1 bg-gray-200 dark:bg-gray-600 mt-1 min-h-[1rem]"></div>
                    }
                  </div>

                  <!-- Contenido del paso -->
                  <div class="flex-1 pb-3">
                    <div class="p-3 bg-gray-50 dark:bg-gray-700/40 rounded-lg border border-gray-200 dark:border-gray-600">
                      <div class="flex items-start gap-2 flex-wrap">
                        <span class="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase">
                          {{ nodeTypeText(step.nodeType, 'Paso') }}
                        </span>
                        <span class="text-xs text-gray-400" [title]="'nodo #' + step.nodeId">{{ getSimNodeName(step.nodeId) }}</span>
                        @if (step.actionType) {
                          <span class="text-xs px-1.5 py-0.5 bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 rounded">
                            {{ nodeSubtypeText(step.actionType) }}
                          </span>
                          <span class="text-xs text-blue-600 dark:text-blue-400 italic">Se ejecutaría</span>
                        }
                        @if (step.nodeType === 'WAIT') {
                          <span class="text-xs text-amber-600 dark:text-amber-400 italic">Esperaría</span>
                        }
                      </div>

                      @if (step.selectedBranchKey) {
                        <div class="mt-1.5 flex items-center gap-1.5">
                          <svg class="w-3 h-3 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
                          </svg>
                          <span class="text-xs text-purple-600 dark:text-purple-400 font-semibold">
                            Rama: {{ branchLabel(step.selectedBranchKey) }}
                          </span>
                          @if (step.nextNodeId) {
                            <span class="text-xs text-gray-400" [title]="'nodo #' + step.nextNodeId">→ {{ getSimNodeName(step.nextNodeId) }}</span>
                          }
                        </div>
                      }

                      @if (step.result && step.result !== 'OK') {
                        <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">{{ step.result }}</p>
                      }
                      @if (step.warnings && step.warnings.length > 0) {
                        @for (w of step.warnings; track $index) {
                          <p class="text-xs text-amber-500 mt-0.5">⚠️ {{ w }}</p>
                        }
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
    </section>

    <!-- 3. Ejecución de prueba -->
    <section class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="px-5 py-4 border-b border-gray-100 dark:border-gray-700">
        <h2 class="text-base font-semibold text-gray-900 dark:text-white">Ejecución de prueba</h2>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          Ejecuta el workflow en modo prueba. Las acciones reales quedan deshabilitadas.
        </p>
      </div>
      <div class="p-5">
        <div class="flex items-center gap-2 text-xs text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-700/40 px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-600 mb-4">
          <svg class="w-4 h-4 shrink-0 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
          Las acciones reales están deshabilitadas en modo prueba. Aparecerán como "Omitido por modo prueba".
        </div>

        <!-- Selector de nodo de inicio -->
        <div class="mb-4">
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Iniciar desde</label>
          @if (nodesLoading) {
            <p class="text-xs text-gray-400 flex items-center gap-1">
              <svg class="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
              </svg>
              Cargando pasos...
            </p>
          } @else if (selectableNodes.length > 0) {
            <select [(ngModel)]="testStartNodeId"
                    class="w-full sm:w-80 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option [value]="null">Desde el inicio del workflow</option>
              @for (node of selectableNodes; track node.id) {
                <option [value]="node.id">{{ getNodeDisplayLabel(node) }}</option>
              }
            </select>
          } @else {
            <div class="flex items-center gap-2">
              <input type="number" [(ngModel)]="testStartNodeId" min="1" placeholder="ID del nodo (opcional)"
                     class="w-48 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
              <button type="button" (click)="loadNodes()"
                      class="px-3 py-2 text-xs border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors">
                Recargar pasos
              </button>
            </div>
          }
        </div>

        <button (click)="runTest()" [disabled]="testLoading"
                class="px-4 py-2 text-sm bg-amber-600 text-white rounded-lg hover:bg-amber-700 disabled:opacity-50 transition-colors flex items-center gap-2 mb-4">
          @if (testLoading) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
          }
          Ejecutar prueba
        </button>

        @if (testError) {
          <p class="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-3 rounded-lg mb-3">{{ testError }}</p>
        }
        @if (testResult) {
          <!-- Metadata del run -->
          <div class="flex flex-wrap gap-3 mb-3">
            <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg px-3 py-2">
              <dt class="text-xs text-gray-500 mb-0.5">Ejecución</dt>
              <dd class="font-mono font-medium text-sm text-gray-900 dark:text-white">#{{ testResult.runId }}</dd>
            </div>
            <div class="bg-amber-50 dark:bg-amber-900/20 rounded-lg px-3 py-2">
              <dt class="text-xs text-gray-500 mb-0.5">Tipo</dt>
              <dd class="text-xs font-bold text-amber-700 dark:text-amber-400">{{ runTypeText(testResult.runType) }}</dd>
            </div>
            <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg px-3 py-2">
              <dt class="text-xs text-gray-500 mb-0.5">Estado</dt>
              <dd>
                <span class="px-2 py-0.5 rounded-full text-xs font-medium"
                      [ngClass]="getTestStepStatusClass(testResult.status)">{{ statusText(testResult.status) }}</span>
              </dd>
            </div>
            @if (testResult.enrollmentId) {
              <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg px-3 py-2">
                <dt class="text-xs text-gray-500 mb-0.5">Inscripción</dt>
                <dd class="font-mono text-sm font-medium text-gray-900 dark:text-white">#{{ testResult.enrollmentId }}</dd>
              </div>
            }
          </div>

          <!-- Resumen de pasos -->
          @if (getTestSummary()) {
            <div class="mb-3 px-3 py-2 bg-gray-50 dark:bg-gray-700/40 rounded-lg border border-gray-200 dark:border-gray-600">
              <p class="text-xs text-gray-600 dark:text-gray-400 font-medium">{{ getTestSummary() }}</p>
            </div>
          }

          @if (testResult.errorMessage) {
            <div class="mb-4 p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
              <p class="text-xs font-semibold text-red-700 dark:text-red-400 mb-1">Error del run</p>
              <p class="text-xs font-mono text-red-600 dark:text-red-300">{{ testResult.errorMessage }}</p>
            </div>
          }

          <!-- Steps -->
          @if (testResult.steps.length > 0) {
            <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Pasos evaluados</h3>
            <div class="space-y-2">
              @for (step of testResult.steps; track $index) {
                <div class="rounded-lg border overflow-hidden"
                     [ngClass]="step.status.toUpperCase() === 'FAILED'
                       ? 'border-red-200 dark:border-red-800'
                       : step.status.toUpperCase() === 'SKIPPED'
                       ? 'border-gray-200 dark:border-gray-600'
                       : 'border-green-200 dark:border-green-800'">
                  <div class="flex items-center gap-3 px-3 py-2.5 bg-gray-50 dark:bg-gray-700/40">
                    <!-- Número -->
                    <span class="text-xs font-mono text-gray-400 w-5 shrink-0">{{ $index + 1 }}</span>
                    <!-- Nodo info -->
                    <div class="flex-1 min-w-0">
                      <div class="flex items-center gap-2 flex-wrap">
                        <span class="text-xs font-medium text-gray-700 dark:text-gray-300" [title]="'nodo #' + step.nodeId">{{ getStepNodeLabel(step) }}</span>
                        @if (step.nodeType) {
                          <span class="text-xs text-gray-400">({{ nodeTypeText(step.nodeType) }})</span>
                        }
                      </div>
                    </div>
                    <!-- Status badge -->
                    <span class="shrink-0 px-2 py-0.5 rounded-full text-xs font-medium"
                          [ngClass]="getTestStepStatusClass(step.status)">
                      {{ isTestModeSideEffect(step) ? 'Omitido por modo prueba' : statusText(step.status) }}
                    </span>
                    <!-- Expandir si hay output -->
                    @if (hasStepOutput(step)) {
                      <button (click)="toggleStepExpand($index)"
                              class="shrink-0 p-1 text-gray-400 hover:text-gray-600 transition-colors">
                        <svg class="w-4 h-4 transition-transform" [class.rotate-180]="expandedSteps.has($index)"
                             fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                        </svg>
                      </button>
                    }
                  </div>
                  <!-- Expandible: output/error -->
                  @if (expandedSteps.has($index)) {
                    <div class="px-3 pb-3 border-t border-gray-100 dark:border-gray-700 pt-2">
                      @if (step.error) {
                        <p class="text-xs font-semibold text-red-600 mb-1">Error</p>
                        <pre class="text-[10px] font-mono text-red-500 bg-red-50 dark:bg-red-900/20 p-2 rounded overflow-x-auto">{{ step.error }}</pre>
                      }
                      @if (step.output && (step.output | json) !== '{}') {
                        <p class="text-xs font-semibold text-gray-500 mt-2 mb-1">Output</p>
                        <pre class="text-[10px] font-mono bg-white dark:bg-gray-800 p-2 rounded border border-gray-200 dark:border-gray-600 overflow-x-auto max-h-32 text-gray-700 dark:text-gray-300">{{ step.output | json }}</pre>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </section>

    <!-- 4. Email de prueba -->
    <section class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="px-5 py-4 border-b border-gray-100 dark:border-gray-700">
        <h2 class="text-base font-semibold text-gray-900 dark:text-white">Email de prueba</h2>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
          Envía un email de prueba a un destinatario alternativo para verificar el contenido renderizado.
        </p>
      </div>
      <div class="p-5">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
          <!-- Selector de nodo email -->
          <div class="sm:col-span-2">
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
              Nodo de email <span class="text-red-500">*</span>
            </label>
            @if (nodesLoading) {
              <p class="text-xs text-gray-400 flex items-center gap-1">
                <svg class="animate-spin w-3 h-3" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
                </svg>
                Cargando nodos...
              </p>
            } @else if (emailNodes.length > 0) {
              <select [(ngModel)]="emailNodeId"
                      class="w-full sm:w-auto px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option [value]="null">— Seleccionar nodo email —</option>
                @for (node of emailNodes; track node.id) {
                  <option [value]="node.id">{{ getNodeDisplayLabel(node) }}</option>
                }
              </select>
              <p class="text-xs text-gray-400 mt-1">Solo se muestran nodos de tipo email.</p>
            } @else {
              <div class="flex items-center gap-2">
                <input type="number" [(ngModel)]="emailNodeId" min="1" placeholder="ID del nodo email"
                       class="w-48 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
                <span class="text-xs text-gray-400">No se encontraron nodos de email en el builder.</span>
              </div>
            }
          </div>

          <div>
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
              Destinatario de prueba <span class="text-red-500">*</span>
            </label>
            <input type="email" [(ngModel)]="emailTo" placeholder="qa@empresa.com"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>

          <div class="p-2.5 bg-gray-50 dark:bg-gray-700/40 rounded-lg border border-gray-100 dark:border-gray-600">
            <p class="text-xs text-gray-500 dark:text-gray-400">Registro de prueba (compartido)</p>
            <p class="text-sm font-medium text-gray-900 dark:text-white break-words">
              {{ recordDisplayText || (sharedObjectId ? recordText(sharedObjectType, sharedObjectId) : 'Selecciona un registro arriba') }}
            </p>
          </div>
        </div>

        <button (click)="sendEmailTest()" [disabled]="emailLoading"
                class="px-4 py-2 text-sm bg-sky-600 text-white rounded-lg hover:bg-sky-700 disabled:opacity-50 transition-colors flex items-center gap-2">
          @if (emailLoading) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
          }
          Enviar email de prueba
        </button>

        @if (emailError) {
          <p class="mt-3 text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-3 rounded-lg">{{ emailError }}</p>
        }
        @if (emailResult) {
          <div class="mt-4 p-4 bg-sky-50 dark:bg-sky-900/20 rounded-lg border border-sky-200 dark:border-sky-800">
            <div class="flex items-center gap-2 mb-3">
              <span class="text-lg">✉️</span>
              <span class="text-sm font-semibold text-sky-800 dark:text-sky-300">Email enviado</span>
              <span class="ml-auto px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-700">{{ statusText(emailResult.status) }}</span>
            </div>
            <dl class="space-y-1.5 text-sm">
              <div class="flex gap-2"><dt class="text-xs text-gray-500 w-20 shrink-0">Para:</dt><dd class="font-medium text-gray-900 dark:text-white">{{ emailResult.to }}</dd></div>
              @if (emailResult.subject) {
                <div class="flex gap-2"><dt class="text-xs text-gray-500 w-20 shrink-0">Asunto:</dt><dd class="text-gray-800 dark:text-gray-200">{{ emailResult.subject }}</dd></div>
              }
              @if (emailResult.previewText) {
                <div class="flex gap-2"><dt class="text-xs text-gray-500 w-20 shrink-0">Preview:</dt><dd class="text-gray-500 dark:text-gray-400 text-xs italic">{{ emailResult.previewText }}</dd></div>
              }
            </dl>
          </div>
        }
      </div>
    </section>

    <!-- 5. Estimación de audiencia -->
    <section class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="px-5 py-4 border-b border-gray-100 dark:border-gray-700">
        <h2 class="text-base font-semibold text-gray-900 dark:text-white">Estimación de audiencia</h2>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Calcula cuántos registros serían elegibles en este momento.</p>
      </div>
      <div class="p-5">
        <div class="flex flex-wrap gap-3 items-end mb-4">
          <div>
            <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Límite de preview</label>
            <input type="number" [(ngModel)]="audienceLimit" min="1" max="100" placeholder="Ej: 10"
                   class="w-28 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>
          <button (click)="estimateAudience()" [disabled]="audienceLoading"
                  class="px-4 py-2 text-sm bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:opacity-50 transition-colors flex items-center gap-2">
            @if (audienceLoading) {
              <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
              </svg>
            }
            Calcular audiencia
          </button>
        </div>

        @if (audienceError) {
          <p class="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-3 rounded-lg mb-3">{{ audienceError }}</p>
        }
        @if (audienceResult) {
          <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
            <div class="bg-gray-50 dark:bg-gray-700/40 rounded-lg p-3 text-center">
              <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ audienceResult.estimatedCount | number }}</p>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Cumplen disparador</p>
            </div>
            <div class="bg-red-50 dark:bg-red-900/20 rounded-lg p-3 text-center">
              <p class="text-2xl font-bold text-red-600 dark:text-red-400">{{ audienceResult.suppressedCount | number }}</p>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Suprimidos</p>
            </div>
            <div class="bg-amber-50 dark:bg-amber-900/20 rounded-lg p-3 text-center">
              <p class="text-2xl font-bold text-amber-600 dark:text-amber-400">{{ audienceResult.alreadyEnrolledCount | number }}</p>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Ya inscritos</p>
            </div>
            <div class="bg-green-50 dark:bg-green-900/20 rounded-lg p-3 text-center">
              <p class="text-2xl font-bold text-green-600 dark:text-green-400">{{ audienceResult.eligibleCount | number }}</p>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Elegibles finales</p>
            </div>
          </div>
          @if (audienceResult.rampUp) {
            <div class="p-3 bg-indigo-50 dark:bg-indigo-900/20 rounded-lg border border-indigo-200 dark:border-indigo-800 mb-4">
              <p class="text-xs font-semibold text-indigo-700 dark:text-indigo-400 mb-1">Ramp-up activo</p>
              <p class="text-sm text-indigo-800 dark:text-indigo-300">
                {{ audienceResult.rampUp.percentage }}% → <strong>{{ audienceResult.rampUp.rampUpCount | number }}</strong> registros iniciales
              </p>
            </div>
          }
          @if (audienceResult.previewObjectIds.length > 0) {
            <div class="mb-4">
              <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Muestra de registros que se inscribirían</p>
              <div class="flex flex-wrap gap-1.5">
                @for (id of audienceResult.previewObjectIds; track id) {
                  <span class="px-2 py-0.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 text-xs font-mono rounded">{{ id }}</span>
                }
              </div>
            </div>
          }
          @if (audienceResult.warnings.length > 0) {
            <div class="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-200 dark:border-amber-800">
              @for (w of audienceResult.warnings; track $index) {
                <p class="text-xs text-amber-600 dark:text-amber-400">⚠️ {{ w }}</p>
              }
            </div>
          }
        } @else if (!audienceLoading) {
          <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-4">
            Haz clic en "Calcular audiencia" para obtener la estimación.
          </p>
        }
      </div>
    </section>

    <!-- 6. Historial de runs -->
    <section class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100 dark:border-gray-700">
        <div>
          <h2 class="text-base font-semibold text-gray-900 dark:text-white">Historial de runs</h2>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Ejecuciones TEST y PRODUCTION de este workflow.</p>
        </div>
        <div class="flex items-center gap-2">
          <select [(ngModel)]="runsFilter"
                  class="px-3 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="">Todos</option>
            <option value="TEST">Solo prueba</option>
            <option value="PRODUCTION">Solo producción</option>
          </select>
          <button (click)="loadRuns()" [disabled]="runsLoading"
                  class="px-3 py-1.5 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 transition-colors flex items-center gap-1.5">
            @if (runsLoading) {
              <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
              </svg>
            } @else {
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
            }
            Cargar
          </button>
        </div>
      </div>
      <div class="p-5">
        @if (runsError) {
          <p class="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-3 rounded-lg">{{ runsError }}</p>
        } @else if (runs.length === 0 && !runsLoading) {
          <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-4">
            Haz clic en "Cargar" para obtener los runs.
          </p>
        } @else {
          <div class="overflow-x-auto">
            <table class="w-full text-sm">
              <thead class="bg-gray-50 dark:bg-gray-700/50 text-xs text-gray-500 dark:text-gray-400">
                <tr>
                  <th class="text-left px-3 py-2 font-medium">Run ID</th>
                  <th class="text-left px-3 py-2 font-medium">Tipo</th>
                  <th class="text-left px-3 py-2 font-medium">Estado</th>
                  <th class="text-left px-3 py-2 font-medium">Inicio</th>
                  <th class="text-left px-3 py-2 font-medium">Fin</th>
                  <th class="text-left px-3 py-2 font-medium">Error</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                @for (run of runs; track run.runId) {
                  <tr class="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
                    <td class="px-3 py-2.5 font-mono text-xs text-gray-500">#{{ run.runId }}</td>
                    <td class="px-3 py-2.5">
                      <span class="px-1.5 py-0.5 rounded text-[10px] font-bold" [ngClass]="getRunTypeBadgeClass(run.runType)">
                        {{ runTypeText(run.runType) }}
                      </span>
                    </td>
                    <td class="px-3 py-2.5">
                      <span class="px-2 py-0.5 rounded-full text-xs font-medium" [ngClass]="getRunStatusClass(run.status)">
                        {{ statusText(run.status) }}
                      </span>
                    </td>
                    <td class="px-3 py-2.5 text-xs text-gray-500">{{ run.startedAt | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td class="px-3 py-2.5 text-xs text-gray-500">{{ run.finishedAt ? (run.finishedAt | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
                    <td class="px-3 py-2.5 text-xs text-red-500 max-w-xs truncate" [title]="run.errorMessage ?? ''">
                      {{ run.errorMessage ?? '—' }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </section>

  </div>
</div>
